import React from 'react';
import styled from 'styled-components';
import { ApiClient } from '../../../../api/ApiClient';
import { v2 } from '../../../../api/ApiInterfaceV2';
import { Currency } from '../../../../platform/Currency';
import { useLoader } from '../../../../platform/Hook';
import { Colors } from '../../../../ui';
import { InfoView } from '../../../../ui/InfoView';
import { LoadingGuard } from '../../../../ui/LoadingGuard';
import { Table } from '../../../../ui/Table';
import { AppNavigator } from '../../../AppNavigator';
import { useResolve } from '../../../Container';
import { Copy, LinkButton } from '../../../dashboard/elements/LayoutElements';
import { TableFrame } from '../../ManageElements';

const { Section, LargeHeading } = InfoView;

const ActionBadge = styled.div<{ color }>`
    display: inline-block;
    position: relative;
    padding: .2rem .4rem;
    border-radius: .3rem;
    color: white;
    font-weight: 450;
    text-transform: uppercase;
    font-size: .875rem;
    background: ${p => p.color};
`;

export const ManageLegacyBillingPaymentsView = React.memo(() => {

    const api = useResolve(ApiClient);
    const nav = useResolve(AppNavigator);

    const [loading, items] = useLoader(async () => await api.exec(v2.admin.billing.payments()), []);

    return <LoadingGuard loading={false}>
        <Section flush>
            <LargeHeading>
                Payment History
            </LargeHeading>
            <Copy>These are all the past and future payments for your organization&apos;s billing.</Copy>
        </Section>
        <TableFrame>
            <Table>
                <Table.Head>
                    <Table.Row>
                        <Table.Cell>Status</Table.Cell>
                        <Table.Cell>Payment Date</Table.Cell>
                        <Table.Cell>Amount</Table.Cell>
                        <Table.Cell>Type</Table.Cell>
                        <Table.Cell></Table.Cell>
                    </Table.Row>
                </Table.Head>
                <Table.Body>
                    {items && items.map(x =>
                        <Table.Row key={x.id}>
                            <Table.Cell>
                                {x.isPaid ? (
                                    <ActionBadge color={Colors.positive}>Paid</ActionBadge>
                                ) : (
                                    <ActionBadge color={Colors.gray400}>Scheduled</ActionBadge>
                                )}
                            </Table.Cell>
                            <Table.Cell>{x.payoutDate}</Table.Cell>
                            <Table.Cell>{Currency.symbolFor(x.currency)}{x.amount.toFixed(2)}</Table.Cell>
                            <Table.Cell>{x.isOneOffCharge ? 'One Off' : 'Recurring'}</Table.Cell>
                            <Table.Cell>
                                {x.receiptUrl && <LinkButton size="xs" target="_blank" to={x.receiptUrl} label="View Receipt" />}
                            </Table.Cell>
                        </Table.Row>
                    )}
                </Table.Body>
            </Table>
        </TableFrame>
    </LoadingGuard>;
});
